<template>
    <div>
        <v-card class="pa-6 mb-4">
            <v-card-title>Revenue Reports</v-card-title>
            <v-card-subtitle>Download all revenue data (Organizations, Invoices, Invoice Items, Subscriptions) as a bundled CSV export.</v-card-subtitle>

            <v-card-text>
                <v-row align="center">
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="startDate"
                            label="Start Date"
                            type="date"
                            variant="outlined"
                            density="compact"
                            hint="Invoices and invoice items will be filtered from this date forward"
                            persistent-hint
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <app-btn
                            @click="downloadRevenueReport"
                            :loading="downloading"
                        >
                            <v-icon left>mdi-download</v-icon>
                            Download (Separate Tables)
                        </app-btn>
                        <app-btn
                            class="mt-2"
                            @click="downloadRevenueReportFlattened"
                            :loading="downloadingFlattened"
                        >
                            <v-icon left>mdi-download</v-icon>
                            Download (Flattened)
                        </app-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="pa-6">
            <v-card-title>Point-in-Time Snapshot</v-card-title>
            <v-card-subtitle>Download revenue data as it would have appeared at the end of a specific date.</v-card-subtitle>

            <v-card-text>
                <v-row align="center">
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="snapshotStartDate"
                            label="Start Date"
                            type="date"
                            variant="outlined"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="snapshotAsOfDate"
                            label="As-Of Date"
                            type="date"
                            variant="outlined"
                            density="compact"
                            hint="Data will reflect what existed on or before this date"
                            persistent-hint
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <app-btn
                            @click="downloadSnapshotReport"
                            :loading="downloadingSnapshot"
                        >
                            <v-icon left>mdi-history</v-icon>
                            Snapshot (Separate Tables)
                        </app-btn>
                        <app-btn
                            class="mt-2"
                            @click="downloadSnapshotReportFlattened"
                            :loading="downloadingSnapshotFlattened"
                        >
                            <v-icon left>mdi-history</v-icon>
                            Snapshot (Flattened)
                        </app-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { getRevenueReportExport, getRevenueReportFlattenedExport } from "@/services/report.service";

export default {
    name: "RevenueReports",
    data() {
        return {
            startDate: '2024-01-01',
            snapshotStartDate: '2024-01-01',
            snapshotAsOfDate: '2026-03-31',
            downloading: false,
            downloadingFlattened: false,
            downloadingSnapshot: false,
            downloadingSnapshotFlattened: false
        }
    },
    methods: {
        async downloadRevenueReport() {
            if (this.downloading) return;
            this.downloading = true;
            try {
                await getRevenueReportExport({
                    startDate: this.startDate
                });
            } finally {
                this.downloading = false;
            }
        },
        async downloadRevenueReportFlattened() {
            if (this.downloadingFlattened) return;
            this.downloadingFlattened = true;
            try {
                await getRevenueReportFlattenedExport({
                    startDate: this.startDate
                });
            } finally {
                this.downloadingFlattened = false;
            }
        },
        async downloadSnapshotReportFlattened() {
            if (this.downloadingSnapshotFlattened) return;
            this.downloadingSnapshotFlattened = true;
            try {
                await getRevenueReportFlattenedExport({
                    startDate: this.snapshotStartDate,
                    asOfDate: this.snapshotAsOfDate
                });
            } finally {
                this.downloadingSnapshotFlattened = false;
            }
        },
        async downloadSnapshotReport() {
            if (this.downloadingSnapshot) return;
            this.downloadingSnapshot = true;
            try {
                await getRevenueReportExport({
                    startDate: this.snapshotStartDate,
                    asOfDate: this.snapshotAsOfDate
                });
            } finally {
                this.downloadingSnapshot = false;
            }
        }
    }
}
</script>
